const MODAL_VIEWS = {
  LIST: 'list',
  EDIT: 'edit',
  DELETE_CONFIRM: 'deleteConfirm',
};

export default MODAL_VIEWS;
